module.exports = __webpack_public_path__ + "media/application/images/svgs/demsoc/lang_bttn-6b805f4debdbd92f2828b0d0fce5534d.svg";